import Joyride, { ACTIONS, CallBackProps, EVENTS, STATUS } from "react-joyride";
import tutorialStyle from "./tutorial.module.css";
import buttonStyle from "../../Common/buttons.module.css";
import { CircleHelp } from "lucide-react";
import { useContext } from "react";
import { AppContext } from "../../../contexts/AppContext";
import { TutorialContext } from "../../../contexts/TutorialContext";
import { CustomTooltip } from "./components/CustomTooltip";
import { CustomBeacon } from "./components/CustomBeacon";
import { useSteps } from "./hooks/useSteps";

export function TutorialToggle() {
  const { tutorial, setTutorial } = useContext(AppContext);
  const { tutorialRefs } = useContext(TutorialContext);

  return (
    <button
      className={
        tutorialStyle.helpButtonPosition +
        " " +
        buttonStyle.button +
        " " +
        buttonStyle.grayOutlineFaded +
        " " +
        buttonStyle.lowPadding +
        " " +
        (tutorial ? buttonStyle.blueButton : "")
      }
      onClick={() => setTutorial(!tutorial)}
      ref={tutorialRefs.helpButtonRef}
    >
      <CircleHelp strokeWidth={1.5} />
    </button>
  );
}

interface Props {
  advance: () => void;
}
export function Tutorial({ advance }: Readonly<Props>) {
  const { tutorial, setTutorial } = useContext(AppContext);
  const { stepIndex, setStepIndex } = useContext(TutorialContext);
  const steps = useSteps();

  // Function called every time joyride state changes
  const handleJoyrideCallback = (data: CallBackProps) => {
    const { status, type, action } = data;

    if (status === STATUS.FINISHED || status === STATUS.SKIPPED) {
      setTutorial(false);
      setStepIndex(0);
      advance();
    } else if (data.index === stepIndex && type === EVENTS.STEP_AFTER) {
      if (action === ACTIONS.PREV && steps[stepIndex].data?.back) setStepIndex(stepIndex - 1);
      else if (steps[stepIndex].data?.next) setStepIndex(stepIndex + 1);
    }
  };

  return (
    <Joyride
      run={tutorial}
      callback={handleJoyrideCallback}
      disableOverlayClose
      spotlightClicks
      stepIndex={stepIndex}
      steps={steps}
      continuous
      tooltipComponent={CustomTooltip}
      beaconComponent={CustomBeacon}
      styles={{
        options: {
          arrowColor: "var(--onedark-background)",
        },
      }}
    />
  );
}
